export const PACKAGE_NAME = 'jiraServiceDeskKnowledgeHub';
